import React from "react";

import { Input } from "@chakra-ui/input";
import {
  HStack,
  Box,
  Icon,
  FormControl,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { MdOutlineSearch } from "react-icons/md";

export const Search = ({ methods, placeholder }) => {
  return (
    <FormControl id="search">
      <HStack alignItems="center" justifyContent="flex-end">
        <Box>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Icon as={MdOutlineSearch} color="gray.400" fontSize="18px" />
            </InputLeftElement>
            <Input
              {...methods.register("search")}
              placeholder={placeholder || "Search"}
              type="search"
              autoComplete="off"
            />
          </InputGroup>
        </Box>
      </HStack>
    </FormControl>
  );
};
